import { $black, $neutralGray10, $neutralGray100, $neutralGray20, $neutralGray30, $neutralGray40, $neutralGray50, $neutralGray60, $neutralGray70, $neutralGray80, $white } from './colors/primitives'

// NOTE: this module holds ONLY plain-data tokens (raw palette / colors /
// layout constants) with no MUI runtime. It must stay import-safe from React
// Server Components. The MUI theme object (MUI_THEME) lives in ./muiTheme.js
// so that importing a color token never eagerly runs createTheme() server-side.

export const HEADER_HEIGHT = '64px'
export const SECONDARY_NAVBAR_DESKTOP_HEIGHT = '48px'

export const PALETTE = {
  white: $white,
  black: $black,
  gray10: $neutralGray10,
  gray20: $neutralGray20,
  gray30: $neutralGray30,
  gray40: $neutralGray40,
  gray50: $neutralGray50,
  gray60: $neutralGray60,
  gray70: $neutralGray70,
  gray80: $neutralGray80,
  gray100: $neutralGray100,

  blue20: '#BFE1FF',
  blue30: '#82C5FF',
  blue50: '#148FFA',
  blue60: '#0670CC'
}

export const COLORS = {
  navbar: PALETTE.gray80,
  navbarBorder: 'rgba(255, 255, 255, 0.20)',
  textPrimary: PALETTE.white,
  ctaSpecialBg: '#E11D48'
}
